export default __webpack_public_path__ + "static/media/Games.f4961faf.png";